import { useMemo } from 'react';
import { SymbolicTeamFormation } from 'modules/championship/domain/enums/symbolic-team-formation';
import { SymbolicTeamFormPlayer } from 'modules/championship/domain/interfaces/symbolic-team-form-player';
import { PlayerCardAvatar, PlayerCardContainer } from './player-card.styles';
import { PlayerInfo } from './player-info';

interface PlayerCardProps {
  className?: string;
  formation: SymbolicTeamFormation;
  player: SymbolicTeamFormPlayer;
  isRankActive: boolean;
  onSelect?: (rank: number) => void;
}

export const PlayerCard = ({ className, player, isRankActive, onSelect }: PlayerCardProps) => {
  const userAvatar = useMemo(() => {
    return isRankActive ? undefined : player.user?.avatar;
  }, [isRankActive, player.user?.avatar]);

  return (
    <div className={className}>
      <PlayerCardContainer>
        <PlayerCardAvatar avatar={userAvatar} />
        <PlayerInfo player={player} isRankActive={isRankActive} onSelect={onSelect} />
      </PlayerCardContainer>
    </div>
  );
};
